export var SceneSubPathType = /*#__PURE__*/ function(SceneSubPathType) {
    SceneSubPathType[SceneSubPathType["Profile"] = 0] = "Profile";
    SceneSubPathType[SceneSubPathType["Replay"] = 1] = "Replay";
    SceneSubPathType[SceneSubPathType["GiftUser"] = 2] = "GiftUser";
    return SceneSubPathType;
}({});
const PROXY_PREFIX = '/.proxy';
const validPaths = [
    '/',
    '/disable-ad-block',
    '/dist',
    '/championship2026-form-application',
    '/championship2026-form-announcement',
    '/championship2026-form-result'
];
const validSceneSubPaths = [
    {
        name: 0,
        pattern: /^\/profile\/[^/]+(?:[#?].*)?$/,
        extractData: (href)=>{
            const match = href.match(/^\/profile\/([^#?]+)/);
            if (!match) return undefined;
            const decodedUsername = decodeURIComponent(match[1]);
            return [
                decodedUsername
            ];
        }
    },
    {
        name: 1,
        pattern: /^\/replay\?gameId=\d+&playerColor=\d+$/,
        extractData: (href)=>{
            const url = new URL(href, 'https://colonist.io');
            const gameId = url.searchParams.get('gameId');
            const playerColor = url.searchParams.get('playerColor');
            return gameId && playerColor ? [
                gameId,
                playerColor
            ] : undefined;
        }
    },
    {
        name: 2,
        pattern: /^\/store(?:\?username=([\w-]+))?#gift$/,
        extractData: (href)=>{
            const match = href.match(/^\/store(?:\?username=([\w-]+))?#gift$/);
            var _match_;
            return match ? [
                (_match_ = match[1]) !== null && _match_ !== void 0 ? _match_ : undefined
            ] : undefined;
        }
    }
];
const validPathPatterns = validPaths.map((link)=>{
    if (link === '/') return new RegExp(`^(${PROXY_PREFIX})?\\/$`);
    return new RegExp(`^(${PROXY_PREFIX})?` + link.replace(/\//g, '\\/') + '.*$');
});
export function isValidPath(href) {
    return validPathPatterns.some((pattern)=>pattern.test(href));
}
export function getValidSubPath(href) {
    const matchedPath = validSceneSubPaths.find(({ pattern })=>pattern.test(href));
    return matchedPath;
}
const LANGUAGE_PREFIX_PATTERN = /^\/[a-z]{2}(?:-[A-Za-z]{2})?(?=\/)/;
export function stripLanguagePrefix(href) {
    return href.replace(LANGUAGE_PREFIX_PATTERN, '');
}
export function stripProxyPrefix(href) {
    return href.startsWith(PROXY_PREFIX) ? href.slice(PROXY_PREFIX.length) : href;
}
